import React, { useState, useEffect } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

const Profile = () => {
  const [profile, setProfile] = useState({
    id: "",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    roNames: JSON.parse(localStorage.getItem("roNames")) || [], // Load RO names from localStorage
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE_URL = "https://api.drivergems.com";

  function generateSignature(method, urlPath, timestamp) {
    const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
    const message = `${method}${urlPath}${timestamp}`;
    return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
  }

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      if (!token) {
        setError("User not authenticated");
        setLoading(false);
        return;
      }

     
      try {
        const timestamp = Math.floor(Date.now() / 1000).toString();

        // Step 1: Fetch User Profile
        const userUrlPath = "/v1/user";
        const userSignature = generateSignature("GET", userUrlPath, timestamp);
        const userResponse = await axios.get(`${API_BASE_URL}${userUrlPath}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Signature": userSignature,
            "X-Timestamp": timestamp,
          },
        });

        const firstname = userResponse.data.firstname || "";
        const lastname = userResponse.data.lastname || "";
        const email = userResponse.data.email || "";
        const phone = userResponse.data.phone || "";

        // Step 2: Fetch RO List (Get ID & Name)
        const rosUrlPath = "/v1/user/ros";
        const rosSignature = generateSignature("GET", rosUrlPath, timestamp);
        const rosResponse = await axios.get(`${API_BASE_URL}${rosUrlPath}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Signature": rosSignature,
            "X-Timestamp": timestamp,
          },
        });

        // ✅ Extract IDs & Names separately
        const roNames = rosResponse.data?.ro_list?.map((ro) => ro.ro_name) || [];
        const roIds = rosResponse.data?.ro_list?.map((ro) => ro.id) || [];

        // Step 3: Save to state and localStorage
        setProfile({
          firstname,
          lastname,
          email,
          phone,
          roNames,
        });

        localStorage.setItem("roNames", JSON.stringify(roNames)); // Store only names for UI
        localStorage.setItem("roIds", JSON.stringify(roIds)); // Store IDs separately (not displayed)

      } catch (error) {
        console.error("Error fetching profile:", error);
        setError("Failed to fetch profile");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  return (
    <div className="profile-page-container">
      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && !error && (
        <>
          <div className="mb-3">
            <strong>First Name:</strong> <span>{profile.firstname}</span>
          </div>
          <div className="mb-3">
            <strong>Last Name:</strong> <span>{profile.lastname}</span>
          </div>
          <div className="mb-3">
            <strong>Email:</strong> <span>{profile.email}</span>
          </div>
          <div className="mb-3">
            <strong>Phone:</strong> <span>{profile.phone}</span>
          </div>
          <div className="mb-3">
            <strong>RO Names:</strong>
            <ul className="list-disc list-inside">
              {profile.roNames.length > 0 ? (
                profile.roNames.map((name, index) => <li key={index}>{name}</li>)
              ) : (
                <p>No RO data available</p>
              )}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default Profile;
